import { type PayloadAction, createSlice } from '@reduxjs/toolkit';
import type { RootState } from '../store';

interface StorageBrowseState {
  currentFolderId: number | null;
  viewMode: 'list' | 'grid';
}

const initialState: StorageBrowseState = {
  currentFolderId: null,
  viewMode: 'list',
};

const storageBrowseSlice = createSlice({
  name: 'storageBrowse',
  initialState,
  reducers: {
    setStorageFolderId: (state, action: PayloadAction<number | null>) => {
      state.currentFolderId = action.payload;
    },
    setStorageViewMode: (state, action: PayloadAction<'list' | 'grid'>) => {
      state.viewMode = action.payload;
    },
  },
});

export const { setStorageFolderId, setStorageViewMode } =
  storageBrowseSlice.actions;

export const selectStorageFolderId = (state: RootState) =>
  state.storageBrowse.currentFolderId;

export const selectStorageViewMode = (state: RootState) =>
  state.storageBrowse.viewMode;

export default storageBrowseSlice.reducer;
